import { colors } from '@ardoq/design-tokens';
import styled from 'styled-components';

export const ErrorSlide = styled.div`
  padding: 50px 100px;
  background-color: ${colors.surfaceDefault};
  height: 100%;
`;
